import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

import { isNative } from '../helpers/device.helper';

const getConfig = (pathname: string): { color: string; style: Style } => {
  switch (pathname) {
    case '/guest/chat':
      return { color: '#e8e2dd', style: Style.Light };
    case '/guest/services':
      return { color: '#c3d7e9', style: Style.Light };
    default:
      return { color: '#f4f4f4', style: Style.Light };
  }
};

export const useSetStatusBar = () => {
  const location = useLocation();

  useEffect(() => {
    const update = async () => {
      if (isNative()) {
        const { color, style } = getConfig(location.pathname);
        if (Capacitor.isPluginAvailable('EdgeToEdge')) {
          await EdgeToEdge.enable();
          await EdgeToEdge.setBackgroundColor({ color });
        }
        if (Capacitor.isPluginAvailable('StatusBar')) {
          await StatusBar.setStyle({ style });
          await StatusBar.setBackgroundColor({ color });
        }
      }
    };

    update();
  }, [location.pathname]);
};
